<template>
  <div>
    <div class="flex-fill d-flex flex-column justify-content-center">
      <div class="container-tight py-6">
        <div class="text-center mb-4 mt-4">
          <a href="/"
            ><img
              :src="require('../../assets/images/logo-dark.png')"
              height="36"
              alt=""
          /></a>
        </div>
        <form class="card card-md" @submit.prevent="signup">
          <div class="card-body">
            <h2 class="mb-5 text-center">創建新帳號</h2>
            <div class="alert alert-danger" v-show="error" role="alert">
              {{ errorMsg }}
            </div>
            <div class="alert alert-success" v-show="success" role="alert">
              {{ successMsg }}
            </div>
            <div class="mb-3">
              <label class="form-label">Email</label>
              <input
                type="email"
                class="form-control"
                placeholder="Enter email"
                v-model="registerForm.email"
              />
            </div>
            <div class="mb-3">
              <label class="form-label">密碼</label>
              <div class="input-group input-group-flat">
                <input
                  type="password"
                  class="form-control"
                  placeholder="Password"
                  v-model="registerForm.password"
                />
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label">重複密碼</label>
              <div class="input-group input-group-flat">
                <input
                  type="password"
                  class="form-control"
                  placeholder="Password"
                  v-model="registerForm.repeatPassword"
                />
              </div>
            </div>
            <div class="mb-3">
              <label class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="agree"
                  value="true"
                />
                <span class="form-check-label"
                  >同意
                  <a
                    href="http://usd2pay.com/zh-tw/disclaimer"
                    tabindex="-1"
                    target="_blank"
                    >使用條款</a
                  >.</span
                >
              </label>
            </div>
            <div class="form-footer">
              <button type="submit" class="btn btn-primary w-100">註冊</button>
            </div>
          </div>
        </form>
        <div class="text-center text-muted mt">
          已經有帳號?
          <router-link to="/login">登入</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      registerForm: {
        email: '',
        password: '',
        repeatPassword: '',
        type: 'PERSONAL',
      },
      errorMsg: '',
      error: false,
      successMsg: '',
      success: false,
      agree: '',
    };
  },
  methods: {
    async signup() {
      this.error = false;
      if (
        this.registerForm.email == '' ||
        this.registerForm.password == '' ||
        this.registerForm.repeatPassword == ''
      ) {
        this.error = true;
        this.errorMsg = '不得為空';
      } else if (
        this.registerForm.password !== this.registerForm.repeatPassword
      ) {
        this.error = true;
        this.errorMsg = '密碼不同';
      } else if (this.agree == '') {
        this.error = true;
        this.errorMsg = '請同意使用條款';
      } else {
        const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/account/register`;
        const sendEmailApi = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/email/send`;
        const vm = this;
        try {
          const result = await this.$http.post(api, vm.registerForm);

          this.successMsg =
            result.data.msg === 'success' ? '註冊成功' : result.data.msg;
          this.success = true;
          this.registerForm.email = '';
          this.registerForm.password = '';
          this.registerForm.repeatPassword = '';
          this.agree = '';

          await this.$http.post(
            sendEmailApi,
            {},
            {
              headers: {Authorization: `Bearer ${result.data.data}`},
            },
          );
        } catch (err) {
          this.error = true;
          if (
            typeof err.response === 'undefined' ||
            err.response.data.message === 'ERR_NOT_ALLOWED'
          ) {
            this.errorMsg = '錯誤';
          } else {
            this.errorMsg = err.response.data.message;
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.page {
  padding-top: 100px;
}
</style>
